'use client';

import { FC, useState } from 'react';
import { Carousel, Slide } from 'atoms/Carousel';
import { ProductTile } from 'organisms/ProductTile';
import { InView } from 'pages/ProductListing/InView';
import { useGTMItemListView } from 'modules/gtm/modules/sections/productList/hooks';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import styles from './styles.module.css';

const breakpoints = {
  MOBILE_WIDTH: 320,
  TABLET_WIDTH: 768,
  SMALL_DESKTOP_WIDTH: 1024,
  DESKTOP_WIDTH: 1280,
  MEDIUM_DESKTOP_WIDTH: 1440,
  LARGE_DESKTOP_WIDTH: 1650,
};

export const Recommendations: FC<{
  products: IAdaptedListProduct[];
}> = ({ products }) => {
  const [state, update] = useState({
    isPrevDisabled: true,
    isNextDisabled: false,
  });

  const { addProductToGTMList } = useGTMItemListView();

  return !products?.length ? null : (
    <div className={styles.recommendations}>
      <Carousel
        spaceBetween={10}
        navigation={{
          nextEl: `.${styles.swiperButtonNext}`,
          prevEl: `.${styles.swiperButtonPrev}`,
        }}
        slidesPerView={1}
        className={styles.carousel}
        slidesPerGroup={1}
        onInit={(swiper) => {
          update((s) => ({
            ...s,
            isPrevDisabled: swiper.isBeginning,
            isNextDisabled: swiper.isEnd,
          }));
        }} // fix displaying next navigation button when there are less slides than slides per view
        onSlideChange={(swiper) =>
          update((s) => ({
            ...s,
            isPrevDisabled: swiper.isBeginning,
            isNextDisabled: swiper.isEnd,
          }))
        }
        breakpoints={{
          [breakpoints.MOBILE_WIDTH]: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          [breakpoints.TABLET_WIDTH]: {
            slidesPerView: 2,
            slidesPerGroup: 1,
          },
          [breakpoints.SMALL_DESKTOP_WIDTH]: {
            slidesPerView: 3,
            slidesPerGroup: 1,
          },
          [breakpoints.DESKTOP_WIDTH]: {
            slidesPerView: 4,
            slidesPerGroup: 2,
          },
          [breakpoints.MEDIUM_DESKTOP_WIDTH]: {
            slidesPerView: 5,
            slidesPerGroup: 2,
          },
          [breakpoints.LARGE_DESKTOP_WIDTH]: {
            slidesPerView: 6,
            slidesPerGroup: 3,
          },
        }}
      >
        {products.map((product) => (
          <Slide key={product.id}>
            <InView
              onVisible={() => {
                addProductToGTMList(product);
              }}
              enable
            >
              <ProductTile product={product} />
            </InView>
          </Slide>
        ))}
      </Carousel>

      <div
        className={`${styles.swiperButtonPrev} swiper-button-prev`}
        style={{ display: state.isPrevDisabled ? 'none' : 'flex' }}
        onMouseDown={(e) => e.preventDefault()}
      />
      <div
        className={`${styles.swiperButtonNext} swiper-button-next`}
        style={{ display: state.isNextDisabled ? 'none' : 'flex' }}
        onMouseDown={(e) => e.preventDefault()}
      />
    </div>
  );
};
